export const MEDIA_TYPES = [
    { label: "SPS Podcast", value: "sps_podcast" },
    { label: "Blog", value: "blog" },
    { label: "Chow", value: "chow" },
    { label: "FSL Podcast", value: "fsl_podcast" }
];

export const STATUS_TYPES = [
    { label: "Failed", value: "failed" },
    { label: "Waiting", value: "waiting" },
    { label: "Ingested", value: "ingested" },
    { label: "Processing", value: "processing" },
    { label: "Suspended", value: "suspended" } // Added suspended status
];
